import { Link } from 'react-router-dom';
import type { Manhwa } from '@/types';

interface LatestUpdatesProps {
  manhwaList: Manhwa[];
}

export default function LatestUpdates({ manhwaList }: LatestUpdatesProps) {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              实时同步最新韩漫章节更新
            </p>
          </div>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 bg-background-200/50 text-xs font-medium text-foreground-500">
            <div className="col-span-5">漫画名称</div>
            <div className="col-span-2">作者</div>
            <div className="col-span-2">状态</div>
            <div className="col-span-2">最近更新</div>
            <div className="col-span-1">评分</div>
          </div>

          {manhwaList.map((manhwa, index) => (
            <Link
              key={manhwa.id}
              to={`/article/${manhwa.id}`}
              className={`grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-6 py-4 items-center hover:bg-background-50 transition-colors cursor-pointer ${
                index < manhwaList.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className="md:col-span-5 flex items-center gap-3">
                <span className="w-5 text-center text-xs font-medium text-foreground-400">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="font-heading text-sm font-medium text-foreground-900 line-clamp-1">
                  {manhwa.title}
                </span>
                <span className="hidden md:inline-flex items-center gap-1 flex-wrap">
                  {manhwa.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-1.5 py-0.5 text-[10px] rounded bg-secondary-100 text-secondary-700"
                    >
                      {tag}
                    </span>
                  ))}
                </span>
              </div>
              <div className="md:col-span-2 text-xs text-foreground-500">
                <span className="md:hidden text-foreground-400">作者：</span>
                {manhwa.author}
              </div>
              <div className="md:col-span-2">
                <span className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-medium ${
                  manhwa.status === '连载中'
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {manhwa.status}
                </span>
              </div>
              <div className="md:col-span-2 text-xs text-foreground-500">
                <span className="md:hidden text-foreground-400">更新：</span>
                {manhwa.updateTime}
              </div>
              <div className="md:col-span-1 flex items-center gap-1">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <span className="text-sm font-semibold text-foreground-800">{manhwa.rating}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}